import AuthLayout from './AuthLayout';
import ErrorLayout from './ErrorLayout';
import Layout from './Layout';
import MainLayout from './MainLayout';
import MinimalLayout from './MinimalLayout';

export { AuthLayout, ErrorLayout, Layout, MainLayout, MinimalLayout };

